// コピーボタン作成用コード
(function(d){
const pre = d.querySelectorAll('pre');
if(pre.length == 0){
    return
}
for(let i = 0; i < pre.length; i++){
    const btn = d.createElement('button');
    btn.className = 'copy-button';
    btn.innerHTML = `
    <span class="copy-icon clipboard-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>
    </span>
    <span class="copy-text">Copy</span>
    `;
    pre[i].insertBefore(btn, pre[i].firstElementChild);
    btn.addEventListener('click', copy_code, false)
}
})(document);

// コピー機能用コード
function copy_code(){
    const code = this.nextElementSibling.innerText;
    const button = this;
    const textSpan = button.querySelector('.copy-text');
    const iconSpan = button.querySelector('.copy-icon');

    if(navigator.clipboard){
    navigator.clipboard.writeText(code).then(() => {
        // 成功時 ✅
        iconSpan.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        `;
        textSpan.textContent = 'コピーしました';
        
        setTimeout(() => {
        // 元に戻す（クリップボード）
        iconSpan.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
        `;
        textSpan.textContent = 'Copy';
        }, 2000);
    }).catch(e => {
        // 失敗時 ❌
        iconSpan.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        `;
        textSpan.textContent = 'コピー失敗';
        
        setTimeout(() => {
        // 元に戻す（クリップボード）
        iconSpan.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </svg>
        `;
        textSpan.textContent = 'Copy';
        }, 2000);
    })
    } else{
    textSpan.textContent = '未対応ブラウザ';
    setTimeout(() => {
        textSpan.textContent = 'Copy';
    }, 2000);
    }
}

// スタイル
const style = document.createElement('style');
style.textContent = `
.copy-button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    font-size: 14px;
    transition: background 0.3s;
    position: absolute;
    top: 0;
    right: 0;
    margin: 0 auto;
    height: 24px;
    border: none;
    line-height: 1;
    font-weight: bold;
    background: #666;
    color: #fff;
    cursor: pointer;
    }
.copy-icon svg {
    width: 16px;
    height: 16px;
}
.copy-icon.clipboard-icon {
    display: contents;
}
`;
document.head.appendChild(style);
